var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { Children, useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, IconButton } from '@mui/material';
var CustomSlider = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var sliderProps = _a.sliderProps, children = _a.children, slideContainerClasses = _a.slideContainerClasses, activeDotColor = _a.activeDotColor, dotColor = _a.dotColor, setCurrentSlide = _a.setCurrentSlide, nextKeyClasses = _a.nextKeyClasses, prevKeyClasses = _a.prevKeyClasses, rightIcon = _a.rightIcon, leftIcon = _a.leftIcon, onLeftIconClick = _a.onLeftIconClick, onRightIconClick = _a.onRightIconClick, onDotClick = _a.onDotClick, slideMaxWidth = _a.slideMaxWidth, preventAutoHeightCalculation = _a.preventAutoHeightCalculation, boxStyles = _a.boxStyles, hideArrows = _a.hideArrows;
    var sliderRef = useRef(null);
    var _l = __read(useState(null), 2), isLeftOrRightIconClicked = _l[0], setIsLeftOrRightIconClicked = _l[1];
    var makeCardsHeightEqualToSliderHeight = function () {
        var _a, _b;
        if (preventAutoHeightCalculation)
            return;
        var minHeight = (_b = (_a = document.getElementsByClassName('slick-slider')) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.clientHeight;
        var cards = document.getElementsByClassName('slick-slide');
        var _loop_1 = function (i) {
            if (cards === null || cards === void 0 ? void 0 : cards.item(i)) {
                cards.item(i).style.height = "".concat(minHeight, "px");
                setTimeout(function () {
                    var _a, _b;
                    (_a = cards.item(i)) === null || _a === void 0 ? void 0 : _a.classList.add('[&>div]:lfc-h-full');
                    if (slideMaxWidth)
                        (_b = cards.item(i)) === null || _b === void 0 ? void 0 : _b.classList.add("".concat(slideMaxWidth));
                }, 0);
            }
        };
        for (var i = 0; i < cards.length; i++) {
            _loop_1(i);
        }
    };
    var handleNavigation = function (direction) {
        var _a, _b;
        if (direction === 'left') {
            (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPrev();
            onLeftIconClick === null || onLeftIconClick === void 0 ? void 0 : onLeftIconClick();
            setIsLeftOrRightIconClicked('left');
        }
        else {
            (_b = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _b === void 0 ? void 0 : _b.slickNext();
            onRightIconClick === null || onRightIconClick === void 0 ? void 0 : onRightIconClick();
            setIsLeftOrRightIconClicked('right');
        }
        makeCardsHeightEqualToSliderHeight();
    };
    // @ts-expect-error: Type assertion needed due to library limitation
    var childrenCount = (_e = (_d = (_c = (_b = Children.toArray(children)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.props) === null || _d === void 0 ? void 0 : _d.children) === null || _e === void 0 ? void 0 : _e.length;
    useEffect(function () {
        makeCardsHeightEqualToSliderHeight();
    }, []);
    return (React.createElement(Box, { sx: __assign({ mb: '25px', position: 'relative', zIndex: 2, '& .slick-arrow': { display: 'none !important' }, '& .slick-dots': {
                bottom: '-35px',
                li: { width: 'auto' },
                '& .slick-active': {
                    div: {
                        backgroundColor: "".concat(activeDotColor !== null && activeDotColor !== void 0 ? activeDotColor : '#BEBBFF', " !important")
                    }
                }
            }, '& .slick-track': {
                display: 'flex !important',
                '.slick-slide': __assign({ margin: '0 8px' }, slideContainerClasses)
            }, 
            // to make text inside slider selectable
            '& .slick-slider': {
                '-webkit-user-select': 'text',
                '-khtml-user-select': 'text',
                '-moz-user-select': 'text',
                '-ms-user-select': 'text',
                'user-select': 'text'
            }, '& .slick-list.draggable': {
                '-webkit-user-select': 'none',
                '-khtml-user-select': 'none',
                '-moz-user-select': 'none',
                '-ms-user-select': 'none',
                'user-select': 'none'
            } }, (boxStyles !== null && boxStyles !== void 0 ? boxStyles : {})) },
        childrenCount > ((_g = (_f = sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slidesToShow) !== null && _f !== void 0 ? _f : sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slidesPerRow) !== null && _g !== void 0 ? _g : 1) && !hideArrows && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { onClick: function () {
                    handleNavigation('left');
                }, className: "  lfc-absolute lfc-rounded-lg lfc-shadow-lg lfc-z-[500] lfc-bg-white ".concat(prevKeyClasses !== null && prevKeyClasses !== void 0 ? prevKeyClasses : 'lfc-bottom-[50%] lfc-translate-y-[50%]   lfc--left-[8px]') }, leftIcon !== null && leftIcon !== void 0 ? leftIcon : React.createElement(KeyboardArrowLeftIcon, null)),
            React.createElement(IconButton, { onClick: function () {
                    handleNavigation('right');
                }, className: "lfc-absolute lfc-rounded-lg lfc-shadow-lg lfc-z-[500]  lfc-bg-white ".concat(nextKeyClasses !== null && nextKeyClasses !== void 0 ? nextKeyClasses : 'lfc-bottom-[50%] lfc-translate-y-[50%] lfc--right-[8px]') }, rightIcon !== null && rightIcon !== void 0 ? rightIcon : React.createElement(KeyboardArrowRightIcon, null)))),
        React.createElement(Slider, __assign({ ref: sliderRef, dots: true, customPaging: function () { return React.createElement("div", { className: "lfc-w-2 lfc-h-2 lfc-rounded-full ".concat(dotColor !== null && dotColor !== void 0 ? dotColor : 'lfc-bg-gray-500') }); }, beforeChange: function () {
                makeCardsHeightEqualToSliderHeight();
            }, afterChange: function (currentSlide) {
                if (isLeftOrRightIconClicked === null) {
                    onDotClick === null || onDotClick === void 0 ? void 0 : onDotClick(currentSlide);
                }
                else {
                    setIsLeftOrRightIconClicked(null);
                }
                setCurrentSlide === null || setCurrentSlide === void 0 ? void 0 : setCurrentSlide(currentSlide);
            }, draggable: false }, sliderProps), (_k = (_j = (_h = Children.toArray(children)) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.props) === null || _k === void 0 ? void 0 : _k.children)));
};
export default CustomSlider;
//# sourceMappingURL=CustomSlider.js.map